if (import.meta.hot) {
  import.meta.hot.accept();
}

import './stage-home.scss';

// Control Video with Play/Pause Button
document.addEventListener('DOMContentLoaded', () => {
  const containers = document.querySelectorAll('.ce-type-twt-stage-home');

  containers.forEach((container) => {
    const videoElement = container.querySelector('video');

    if (videoElement) {
      // Dynamic import only if video exists
      import('@assets/JavaScript/stage-video-control.js').then(({ initVideoControl }) => {
        initVideoControl(container);
      });
    }
  });
});
